var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-section report-section-header"},[_c('h1',{attrs:{"data":"$title"}},[_vm._v(_vm._s(_vm.reportData.report_title))]),_c('p',[_c('span',[_vm._v(_vm._s(_vm.reportData.greeting))])]),_c('p',[_c('span',[_vm._v(_vm._s(_vm.reportData.duration))])]),_c('p',[_c('span',[_vm._v(_vm._s(_vm.reportData.create_time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }